export default __webpack_public_path__ + "static/media/delete_mobility_plan.e8c004ee.svg";